'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('@emotion/styled');
var styledComponents = require('../common/styledComponents.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const RouletteContainer = styled__default["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: inline-block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  flex-shrink: 0;
`;
const RotationContainer = styled__default["default"].div(
  ({
    startSpinningTime,
    startRotationDegrees,
    continueSpinningTime,
    stopSpinningTime,
    finalRotationDegrees,
    classKey
  }) => `
  position: absolute;
  width: 100%;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(${startRotationDegrees}deg);
  pointer-events: none;
  border-radius: 50%;
  overflow: hidden;

  &.started-spinning {
    animation: spin-${classKey} ${startSpinningTime / 1e3}s
        cubic-bezier(0.71, -0.29, 0.96, 0.9) 0s 1 normal forwards running,
      continueSpin-${classKey}
        ${continueSpinningTime / 1e3}s
        linear ${startSpinningTime / 1e3}s 1
        normal forwards running,
      stopSpin-${classKey} ${stopSpinningTime / 1e3}s
        cubic-bezier(0, 0, 0.35, 1.02)
        ${(startSpinningTime + continueSpinningTime) / 1e3}s
        1 normal forwards running;
  }

  @keyframes spin-${classKey} {
    from {
      transform: rotate(${startRotationDegrees}deg);
    }
    to {
      transform: rotate(${startRotationDegrees + 360}deg);
    }
  }
  @keyframes continueSpin-${classKey} {
    from {
      transform: rotate(${startRotationDegrees}deg);
    }
    to {
      transform: rotate(${startRotationDegrees + 360}deg);
    }
  }
  @keyframes stopSpin-${classKey} {
    from {
      transform: rotate(${startRotationDegrees}deg);
    }
    to {
      transform: rotate(
        ${1440 + finalRotationDegrees}deg
      );
    }
  }
`
);
styled__default["default"](styledComponents.NonDraggableImage)`
  position: absolute;
  z-index: 5;
  width: 17%;
  right: 6px;
  top: 15px;
`;

exports.RotationContainer = RotationContainer;
exports.RouletteContainer = RouletteContainer;
